import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  lotCard: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    border: `2px solid ${theme.palette.secondary.main}`,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    cursor: 'pointer',
    transition: 'all 0.2s ease',

    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
    }
  },

  cardHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  iconContainer: {
    width: 56,
    height: 56,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  icon: {
    width: 48,
    height: 48,
    objectFit: 'contain'
  },

  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4,
    textAlign: 'center'
  },

  lotName: {
    margin: 0,
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.primary.main,
    wordBreak: 'break-word'
  },

  regime: {
    fontSize: 14,
    color: '#6D6D6D',
    fontWeight: 400
  },

  cardFooter: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 8,
    borderTop: `1px solid ${theme.palette.divider}`
  },

  animalCount: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 16px',
    backgroundColor: theme.palette.primary.main + '10',
    borderRadius: 20
  },

  countLabel: {
    fontSize: 14,
    color: '#6D6D6D',
    fontWeight: 400
  },

  countValue: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.primary.main
  }
}))
